export default "__VITE_ASSET__iGQCj8c3__"